import React from 'react';
import styles from './CustomModal.module.scss';
import cn from 'classnames';
import { Button } from 'antd';

export const CustomModal = ({
  render,
  visible = false,
  title = '',
  okText = 'Ок',
  cancelText = 'Отменить',
  onCancel,
  onOk,
  renderCustomActions,
  okButtonType = 'primary',
  cancelButtonType = '',
}) => {
  if (!visible || typeof render !== 'function') return null;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        <Button
          icon="close"
          className={styles.close}
          onClick={onCancel}
        />
      </div>
      <div className={styles.body}>{render()}</div>
      <div className={cn(styles.footer)}>
        <div className={styles.custom_actions}>
          {typeof renderCustomActions === 'function' && renderCustomActions()}
        </div>
        <div className={styles.actions}>
          <Button
            type={cancelButtonType}
            htmlType="button"
            onClick={onCancel}
          >
            {cancelText}
          </Button>
          <Button
            type={okButtonType}
            htmlType="submit"
            onClick={onOk}
          >
            {okText}
          </Button>
        </div>
      </div>
    </div>
  );
};
